import React from 'react';
import { X, Check } from 'lucide-react';
export function Comparison() {
  return <section className="bg-white text-navy py-12" data-id="element-31">
      <div className="max-w-md mx-auto px-4" data-id="element-32">
        <h2 className="text-xl font-bold text-center mb-8" data-id="element-33">
          Sin Flauta Master Class vs. Con Flauta Master Class
        </h2>

        <div className="bg-gray-50 rounded-2xl border border-gray-200 overflow-hidden" data-id="element-34">
          <div className="grid grid-cols-2 text-sm font-bold border-b border-gray-200" data-id="element-35">
            <div className="p-3 text-center text-red-600 bg-red-50/50 flex flex-col items-center gap-1" data-id="element-36">
              <X className="w-5 h-5" data-id="element-37" />
              <span data-id="element-38">Sin el sistema</span>
            </div>
            <div className="p-3 text-center text-turquoise bg-turquoise/10 flex flex-col items-center gap-1" data-id="element-39">
              <Check className="w-5 h-5" data-id="element-40" />
              <span data-id="element-41">Con el sistema</span>
            </div>
          </div>

          {[['Armás cada acto desde cero', 'Repertorio listo por fecha y ocasión'], ['Buscás partitura por partitura en internet', 'Banco de +200 partituras organizadas'], ['Repetís siempre las mismas canciones', 'Repertorio variado por trimestre'], ['No tenés nada para pedidos puntuales', 'Variantes por nivel y contexto'], ['El acto se siente desordenado', 'Repertorio y planificación, todo listo']].map((row, idx) => <div key={idx} className="grid grid-cols-2 text-xs border-b border-gray-100 last:border-0" data-id="element-42">
              <div className="p-3 text-gray-600 border-r border-gray-100" data-id="element-43">
                {row[0]}
              </div>
              <div className="p-3 font-medium text-navy bg-turquoise/5" data-id="element-44">
                {row[1]}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}